<template lang="">
  <div id="wrap">
    <section id="subVisual" class="subVis2">
      <div>
        <h2>SYSMIND</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>

    <!-- container -->
    <main id="cont" class="product_sees">
      <div class="subCon seesCon inner_box">
        <section id="sysmind">
          <h3 class="con_tit">SYSMIND 소개</h3>
          <div class="sstxt">
            <h4>
              시스템 운영 자동화 솔루션이 제공하는
              <span><strong>자동화의 범위</strong>를 알려드립니다.</span>
            </h4>
            <p>
              종료/재기동 업무 자동화 및 다량의 시스템에 대한 관리 업무 자동화를
              포함하여, 기타 시스템 관련 업무에 대한 자동화를 지원하는 것을
              범위로 합니다. <br />이러한 자동화 시스템은 시스템 작업의 안정성을
              위하여 중앙 집중 관리 및 통제를 기반으로 합니다
            </p>
          </div>

          <section class="con">
            <section class="kind clearfix">
              <dl>
                <dt>기동/재기동업무자동화</dt>
                <dd>
                  <ul>
                    <li>
                      - 전원작업, 시스템 장애, 예방점검(PM) 등 <br />계획된
                      시스템 종료/재기동 작업의 자동화
                    </li>
                    <li>- 재해복구시스템 전환 환원 자동화</li>
                  </ul>
                </dd>
              </dl>
              <dl>
                <dt>일상점검 업무자동화</dt>
                <dd>
                  <ul>
                    <li>
                      - 매일 IT장비와 서비스에 대한 예방점검을 <br />수행하여
                      장애를 미연에 방지
                    </li>
                    <li>- 점검 항목의 변경에 대한 유연성 제공</li>
                  </ul>
                </dd>
              </dl>
              <dl>
                <dt>CI구성관리 업무자동화</dt>
                <dd>
                  <ul>
                    <li>
                      - 시스템의 H/W 및 S/W 구성정보 <br />수집 작업의 자동화
                    </li>
                    <li>- 시스템에 대한 체계적인 관리</li>
                  </ul>
                </dd>
              </dl>
              <dl>
                <dt>S/W 배포 업무자동화</dt>
                <dd>
                  <ul>
                    <li>
                      - 대량의 시스템에 대한 S/W 최신버전(패치포함)
                      <br />업데이트 및 패치 작업 수행
                    </li>
                  </ul>
                </dd>
              </dl>
              <dl>
                <dt>수행결과수집 업무자동화</dt>
                <dd>
                  <ul>
                    <li>
                      - 각 응용프로그램 특성에 따른 대상 <br />시스템 수행 결과
                      수집 자동화<br class="br" />(예) 보안취약점 점검 수행 및
                      결과 수집 자동화
                    </li>
                  </ul>
                </dd>
              </dl>
              <dl>
                <dt>기타 시스템 업무자동화</dt>
                <dd>
                  <ul>
                    <li>- 각종 비정기 정보 수집 및 시스템 작업의 자동화</li>
                    <li>- 기타 시스템 관련 반복 수행 업무 자동화</li>
                  </ul>
                </dd>
              </dl>
            </section>

            <div class="titBox gbg">
              <h5>운영 관리 및 통제</h5>
              <div class="conBox g clearfix">
                <p class="rdot">시스템 운영 관리 업무의 중앙 집중 관리</p>
                <p class="rdot">
                  접근 제한 및 배포 기능 통제(시스템 수행 쉘 소스 포함)
                </p>
              </div>
            </div>

            <div class="titBox rbg">
              <h5>보안 체계</h5>
              <div class="conBox">
                <ul class="clearfix">
                  <li>
                    <v-img
                      src="@/assets/img/product/sees/sees_icon1-1.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 30%;
                        align-items: center;
                      "
                    />
                    <p>웹 취약점 보안</p>
                  </li>
                  <li>
                    <v-img
                      src="@/assets/img/product/sees/sees_icon1-2.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 30%;
                        align-items: center;
                      "
                    />
                    <p>접속 권한 보안</p>
                  </li>
                  <li>
                    <v-img
                      src="@/assets/img/product/sees/sees_icon1-3.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 30%;
                        align-items: center;
                      "
                    />
                    <p>주요자료 암호화</p>
                  </li>
                  <li>
                    <v-img
                      src="@/assets/img/product/sees/sees_icon1-4.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 30%;
                        align-items: center;
                      "
                    />
                    <p>네트워크 전송 암호화</p>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </section>
        <!-- #sysmind -->
      </div>
    </main>
  </div>
</template>
<script>

export default {

}
</script>
<style lang=""></style>
